import React from 'react';
import Loader from '../../../../assets/images/spinner-DNA-2s-200px.svg';
function LoadingSearchIndicator() {
  return /*#__PURE__*/React.createElement("div", {
    className: "loading-container"
  }, /*#__PURE__*/React.createElement("img", {
    alt: "loader",
    src: Loader
  }));
}
export default LoadingSearchIndicator;